export default __webpack_public_path__ + "static/unknown-a9136072d073801df253d6c3e74febd5.png";